import { useTheme, type Breakpoint } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

type BreakpointDirection = 'up' | 'down' | 'only';

export const useBreakpoint = (
	breakpoint: Breakpoint,
	direction: BreakpointDirection
) => {
	const theme = useTheme();
	return useMediaQuery(theme.breakpoints[direction](breakpoint));
};
